import type { TinType, VendorTax, VendorTaxStatus } from "@/api/types";

/**
 * ef-064-18 anchor (Spec Architect, FROZEN) - the words of a payee's tax status and the three kinds of tax ID, as the screen spells them. The
 * Playwright spec asserts these exact strings. Display only: nothing on the client decides readiness (the server's `status` / `missing` do).
 */
export const TIN_TYPES: readonly { value: TinType; label: string }[] = [
  { value: "ssn", label: "SSN" },
  { value: "ein", label: "EIN" },
  { value: "itin", label: "ITIN" },
];

export function taxStatusLabel(tax: Pick<VendorTax, "status" | "missing">): string {
  const status: VendorTaxStatus = tax.status;
  if (status === "ready") return "Ready for 1099";
  if (status === "exempt") return "Not on a 1099";
  const taxId = tax.missing.includes("taxId");
  const address = tax.missing.includes("address");
  if (taxId && address) return "Missing tax ID and address";
  return taxId ? "Missing tax ID" : "Missing address";
}
